import React from 'react';
import { Mail, MessageCircle, FileText } from 'lucide-react';
import { Input, Button, Form, message } from 'antd';

const { TextArea } = Input;

export default function Support() {
  const onFinish = (values) => {
    message.success('Сообщение отправлено! Мы ответим в течение 15 минут.');
  };

  return (
    <div className="max-w-2xl mx-auto space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-white mb-2">Поддержка</h1>
        <p className="text-slate-400">Мы здесь, чтобы помочь. Выберите удобный способ связи.</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <a href="https://t.me/luckstat_support" target="_blank" rel="noopener noreferrer" 
           className="bg-[#2AABEE]/10 hover:bg-[#2AABEE]/20 border border-[#2AABEE]/30 p-4 rounded-xl flex items-center justify-center gap-3 transition-colors group">
          <MessageCircle className="text-[#2AABEE]" />
          <span className="text-white font-medium group-hover:text-[#2AABEE] transition-colors">Telegram Chat</span>
        </a>
        <a href="mailto:support@luckstat.com" 
           className="bg-white/5 hover:bg-white/10 border border-white/10 p-4 rounded-xl flex items-center justify-center gap-3 transition-colors">
          <Mail className="text-slate-300" />
          <span className="text-white font-medium">Email</span>
        </a>
      </div>

      <div className="bg-surface p-8 rounded-2xl border border-white/5">
        <h2 className="text-xl font-bold text-white mb-6">Написать нам</h2>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="subject" label={<span className="text-slate-300">Тема</span>} rules={[{ required: true }]}>
            <Input className="input-field" placeholder="У меня вопрос по..." />
          </Form.Item>
          <Form.Item name="message" label={<span className="text-slate-300">Сообщение</span>} rules={[{ required: true }]}>
            <TextArea rows={5} className="input-field" placeholder="Опишите вашу проблему подробно..." />
          </Form.Item>
          <Button type="primary" htmlType="submit" className="w-full h-12 bg-primary hover:bg-primary/90 border-none text-lg">
            Отправить
          </Button>
        </Form>
      </div>

      <div className="text-center">
        <a href="#" className="text-slate-500 hover:text-white text-sm flex items-center justify-center gap-2 transition-colors">
          <FileText size={14} />
          База знаний и документация
        </a>
      </div>
    </div>
  );
}
